<template>
	<div class="form-group">
		<span id="file-input-container">
		    <label id="fileInputLabel" for="fileInput_0">
		    	<a class="btn btn-primary" id="addFileBtn">
	                <i class="fas fa-plus"></i>
	                <span>&nbsp;{{label}}</span>
	            </a>
		    </label>
		    <i>{{maxFiles}} fichier{{(maxFiles>1)?'s':''}} max, {{maxFileSizeReadable}} max par fichier. </i>
		    <input type="file" class="form-control-file" id="fileInput_0" name="fileInput[]" :accept="accept" hidden>
		</span>
	    <ul id="filesList">
	    	<li v-for="(value, name) in files">{{value.name}}<a @click="removeFile(name)"><i class="fas fa-times-circle"></i></a></li>
	    </ul>
	    <ul class="alert alert-danger" v-if="errors.length>0">
	    	<li v-for="error in errors">{{error}}</li>
	    </ul>
  	</div>
</template>
<script>
    export default{
        name: 'vMultipleUpload',
        props: {
            label: {
            	type: String,
                default: 'Ajouter des fichiers...'
            },
            maxFiles: {
            	type: Number,
            	default:5
            },
            maxFileSize: {
            	type: Number,
            	default:10000000 //10Mo (decimal mesurement)
            },
            accept: {
            	type: String,
            	default:"*"
            }
        },
        data(){
            return{
                files: {},
                errors:[]
            }
        },
        mounted(){
        	let vueIntance = this;

        	$(document).on('change',"input[id^='fileInput_']", function() {
        		vueIntance.errors=[]
        		if($(this)[0].files[0].size<=vueIntance.maxFileSize){
	        		let oldNb = parseInt($(this).attr('id').split('_')[1])
					vueIntance.files=Object.assign({},vueIntance.files,{[oldNb]:$(this)[0].files[0]})
					let newId="fileInput_"+(oldNb+1)
			    	let newInput = $('<input type="file" class="form-control-file" id="'+newId+'" name="fileInput[]" hidden accept="'+this.accept+'">')
			    	$(this).parent().append(newInput);//create new input and hide the previous input
			    	$("#fileInputLabel").attr('for',newId)

					if(Object.keys(vueIntance.files).length>=vueIntance.maxFiles){//if max file is reach hide the button
				    	$("#file-input-container").hide();
				    }
				}else{
					$(this)[0].value="";//reset input if file is too big
					vueIntance.errors.push("Le fichier que vous avez sélectionné est trop volumineux.")
				}
		    })

        },
        computed: {
        	maxFileSizeReadable:function(){
        		let i = Math.floor(Math.log(this.maxFileSize) / Math.log(1000));
    			return (this.maxFileSize / Math.pow(1000, i)).toFixed(2) * 1 +' '+['Octets', 'Ko', 'Mo', 'Go', 'To'][i];
        	}
        },
        methods: {
        	removeFile: function(i){
        		$("#fileInput_"+i)[0].remove();
        		this.$delete(this.files,i)
        		if(Object.keys(this.files).length<this.maxFiles){
        			$("#file-input-container").show();
        		}
        	}
        }
    }
    
</script>
<style type="text/css">
	#filesList {
		list-style: none;
	}
	input[id^="fileInput_"]{
		display: none !important;
	}
</style>

